<template>
    <v-navigation-drawer
        v-model="isDrawerActive"
        app
        clipped
        fixed
        :expand-on-hover="$vuetify.breakpoint.lgAndUp"
        :mini-variant="$vuetify.breakpoint.lgAndUp"
    >
        <v-list nav dense shaped>
            <template
                v-for="item in menuItems"
            >
                <v-list-group
                    v-if="item.subMenuItems.length > 0"
                    :key="item.menuTitle"
                    v-model="item.active"
                    :prepend-icon="item.icon"
                    no-action
                    active-class="secondary--text"
                >
                    <template #activator>
                        <v-list-item-title>{{ item.menuTitle }}</v-list-item-title>
                    </template>

                    <v-list-item
                        v-for="subItem in item.subMenuItems"
                        :key="subItem.menuTitle"
                        :to="subItem.path"
                        active-class="secondary--text"
                    >
                        <v-list-item-content>
                            <v-list-item-title>{{ subItem.menuTitle }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>

                <v-list-item
                    v-else
                    :key="item.menuTitle"
                    :to="item.path"
                    active-class="secondary--text"
                >
                    <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                        <v-badge
                            v-if="item.badge && item.badge.count"
                            bordered
                            color="primary"
                            :content="item.badge.count"
                            right
                            overlap
                        />
                    </v-list-item-icon>

                    <v-list-item-title>
                        {{ item.menuTitle }}
                    </v-list-item-title>
                </v-list-item>
            </template>
        </v-list>

        <template #append>
            <v-divider />
            <v-list nav dense shaped>
                <v-list-item
                    active-class="secondary--text"
                    @click="openReleaseNotes"
                >
                    <v-list-item-icon>
                        <v-icon>mdi-newspaper-variant-outline</v-icon>
                    </v-list-item-icon>

                    <v-list-item-title>
                        Co nowego?
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </template>
    </v-navigation-drawer>
</template>

<script>
import { hasUserPermission } from '@/utils/permissionsHandler'
import { errorHandler } from '@/utils/errorHandler'
import { EventBus } from '@/utils/eventBus'
import { findIndex } from 'lodash'

export default {
    props: {
        drawer: {
            type: Boolean
        }
    },
    data() {
        return {
            menuItems: []
        }
    },
    computed: {
        userId() {
            return this.$store.state.user.userId
        },
        isDrawerActive: {
            get: function() {
                return this.drawer
            },
            set: function(value) {
                this.$emit('toggle-drawer', value)
            }
        },
    },
    mounted() {
        this.getUserTasksCount()
        this.getUserProductionSiteNoteCount()
    },
    created() {
        this.renderMenu()

        EventBus.$on('getUserTasks', () => { this.getUserTasksCount() })
        EventBus.$on('updatedProductionSiteNoteCount', (v) => { this.updateProductionSiteNoteCount(v) })
    },
    destroyed() {
        EventBus.$off()
    },
    methods: {
        toggleDrawer(value) {
            this.$emit('toggleDrawer', value)
        },
        openReleaseNotes() {
            this.$store.dispatch('releaseNotes/fetchLatestVersion')
                .then(() => {
                    this.$store.commit('releaseNotes/SET_SHOW_DIALOG', true)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        renderMenu() {
            this.$router.options.routes.forEach(route => {
                if (route.meta.menuRendered) {
                    const parent = {
                        menuTitle: route.meta.menuTitle,
                        path: route.path,
                        icon: route.meta.icon,
                        badge: route.meta.badge,
                        subMenuItems: []
                    }

                    let showParent = false

                    if (route.meta.permission && !hasUserPermission(route.meta.permission)) {
                        return
                    }

                    if (route.meta.permission && hasUserPermission(route.meta.permission)) {
                        showParent = true
                    }

                    if (route.children) {
                        route.children.forEach(child => {
                            if (child.meta.menuRendered && child.meta.permission && hasUserPermission(child.meta.permission)) {
                                showParent = true

                                parent.subMenuItems.push({
                                    menuTitle: child.meta.menuTitle,
                                    path: child.path
                                })
                            }
                        })

                        if (showParent) {
                            this.menuItems.push(parent)
                        }
                    } else {
                        this.menuItems.push(parent)
                    }
                }
            })
        },
        getUserTasksCount() {
            if (hasUserPermission('user_tasks_read') || hasUserPermission('user_tasks_admin_read')) {
                this.$store.dispatch('userTasks/getUserTasks', {
                    paginate: '',
                    query: '?userTaskStatus=10' // Not finished
                })
                    .then(response => {
                        const index = findIndex(this.menuItems, item => {
                            return item.badge && item.badge.name == 'userTasksCount'
                        })

                        this.menuItems[index].badge.count = response.data.count
                    })
                    .catch(error => {
                        errorHandler(error)
                    })
            }
        },
        getUserProductionSiteNoteCount() {
            if (hasUserPermission(['production_sites_notes_admin_read', 'production_sites_note_leader_read'])) {
                this.$store.dispatch('notes/getUnreadProductionSiteNotes', this.userId)
                    .then(response => {
                        this.updateProductionSiteNoteCount(response.data.count)
                    })
                    .catch(error => {
                        errorHandler(error)
                    })
            }
        },
        updateProductionSiteNoteCount(count) {
            const index = findIndex(this.menuItems, item => {
                return item.badge && item.badge.name == 'userProductionSiteNoteCount'
            })

            this.menuItems[index].badge.count = count
            this.$store.dispatch('notes/setUnreadProductionSiteNoteCount', count)
        }
    }
}
</script>
